/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicLinkLogin
 */
export interface MagicLinkLogin {
    /**
     * 
     * @type {string}
     * @memberof MagicLinkLogin
     */
    token: string;
}

/**
 * Check if a given object implements the MagicLinkLogin interface.
 */
export function instanceOfMagicLinkLogin(value: object): value is MagicLinkLogin {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function MagicLinkLoginFromJSON(json: any): MagicLinkLogin {
    return MagicLinkLoginFromJSONTyped(json, false);
}

export function MagicLinkLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicLinkLogin {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

  export function MagicLinkLoginToJSON(json: any): MagicLinkLogin {
      return MagicLinkLoginToJSONTyped(json, false);
  }

  export function MagicLinkLoginToJSONTyped(value?: MagicLinkLogin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

